/* DOLL — salidas del menú móvil.

   .doll-nav-panel es position:fixed con inset:0, así que al abrirse tapa la
   cabecera entera — incluido el botón de menú, que es lo único que sabía
   cerrarlo. En el teléfono eso dejaba el menú sin salida: la tecla Escape que
   maneja doll.js no existe ahí.

   Se agregan dos salidas:

   1. Una X dentro del panel. Va con [data-doll-nav-close], que es lo que ya
      busca el handler delegado de initMobileNav, así que no necesita listener
      propio.

   2. Una franja vertical al costado derecho. Esta cuelga del <body>, NO del
      panel: el panel ahora termina en el 80% (ver doll-header-fix.css) y todo
      lo que cuelgue de él queda dentro de esa caja. Al estar fuera no le
      sirve el handler delegado, así que cierra dando un click al botón de
      menú, que es quien ya sabe abrir y cerrar. Solo se muestra con
      html.doll-nav-open — clase que pone doll.js — para que con el menú
      cerrado no se coma los toques de la página.

   El aspecto de ambos está en assets/doll-header-fix.css. */
(function () {
  'use strict';

  var escapeEl = null;

  function initNavExits() {
    var toggle = document.querySelector('[data-doll-nav-toggle]');
    var panel = document.querySelector('[data-doll-nav-panel]');
    if (!toggle || !panel) return;

    if (!panel.hasAttribute('data-doll-nav-exits')) {
      panel.setAttribute('data-doll-nav-exits', '');

      // Primero en el DOM a propósito: doll.js enfoca el primer a/button del
      // panel al abrirlo, y cerrar es un buen lugar donde aterrizar.
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'doll-nav-panel__close';
      closeBtn.setAttribute('aria-label', 'Cerrar menú');
      closeBtn.setAttribute('data-doll-nav-close', '');
      panel.insertBefore(closeBtn, panel.firstChild);
    }

    if (!escapeEl || !escapeEl.isConnected) {
      escapeEl = document.createElement('button');
      escapeEl.type = 'button';
      escapeEl.className = 'doll-nav-escape';
      escapeEl.setAttribute('aria-label', 'Cerrar menú');
      document.body.appendChild(escapeEl);
    }

    // onclick y no addEventListener: en el editor de Shopify esto se vuelve a
    // ejecutar en cada recarga de sección y así se reemplaza en vez de apilar.
    escapeEl.onclick = function () {
      if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavExits);
  } else {
    initNavExits();
  }

  document.addEventListener('shopify:section:load', initNavExits);
})();
